import { render, staticRenderFns } from "./CartAdditionalRequestModal.vue?vue&type=template&id=2229a966&scoped=true&"
import script from "./CartAdditionalRequestModal.vue?vue&type=script&lang=js&"
export * from "./CartAdditionalRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./CartAdditionalRequestModal.vue?vue&type=style&index=0&id=2229a966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229a966",
  null
  
)

export default component.exports